import React from 'react';
import { Navbar, NavItem } from 'react-materialize';
import './NavBar.css'
import Headroom from 'react-headroom';
import github from '../../assets/github-original.svg';
import mail from '../../assets/letter.svg';
import linkedin from '../../assets/linkedin-original.svg';

const NavBar = () => {

    return (
        // <Headroom>
            <Navbar brand='Nicholas J Cowan' id="navbar" href="/"right fixed>
                <NavItem href='#aboutMe'>About Me</NavItem>
                <NavItem href='#portfolio'>Portfolio</NavItem>
                <NavItem href='https://github.com/Nismo-Gtr'id="navLinks"><img src={github} alt="Git Hub Logo"/></NavItem>
                <NavItem href='https://linkedin.com/in/thenicholascowan' id="navLinks"><img src={linkedin} alt="Linked in Logo"/></NavItem>
                <NavItem href='mailto:Nick@TheNicholasCowan.com' id="navLinks"><img src={mail} alt="email link"/></NavItem>
            </Navbar>
        // </Headroom>
    )
}

export default NavBar;


// WEBPACK FOOTER //
// ./src/components/NavBar/NavBar.js